var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "#e9e8e8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconPin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 282",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconPin_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 389",
    fill: "none",
    d: "M0 0h56v56H0z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 400",
    width: 56,
    height: 56,
    rx: 8,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "IconPin",
    clipPath: "url(#IconPin_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 386",
    clipPath: "url(#IconPin_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 565",
    d: "M33.818 33.984a5.508 5.508 0 01-.217 7.558l-.079.079a1.169 1.169 0 01-1.65 0l-7.149-7.152-7.348 7.348c-.163.159-3.752 3.64-6.608 5.931-2.735 2.194-3.222 2.616-3.241 2.634a1.167 1.167 0 01-1.647-1.647c.023-.026.452-.523 2.634-3.244 2.289-2.856 5.773-6.445 5.92-6.6l7.357-7.357-7.553-7.555a1.164 1.164 0 010-1.65l.077-.079a5.511 5.511 0 017.56-.217l11.949-10.248 10.25 10.251z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 566",
    d: "M50.07 20.044l-.054.054a4.092 4.092 0 01-4.874.688L35.064 10.718a4.086 4.086 0 01.686-4.874l.054-.054a1.167 1.167 0 011.65 0L50.07 18.397a1.167 1.167 0 010 1.65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/IconPin.39cf12b788480002.svg";
export { ForwardRef as ReactComponent };